(function () {
  /**
   * Vertaal alle links naar de juiste taal. Dit werkt niet 100%, maar is een quick fix.
   * Alle pagina's/producten die vanuit Shopify worden gelinkt in de WYSIWYG editor, worden niet automatisch mee vertaald.
   * Dus een /collections/verzwaringsdeken-hoezen is in de engelse website nog steeds een Nederlandse verwijzing.
   * Door er /en/ voor te zetten, verwijzen we in ieder geval binnen de engelse namespace. Shopify redirect dan vervolgens die pagina naar de juiste url.
   */
  if (!(location.pathname === '/en' || location.pathname.startsWith('/en/'))) return;

  const root = document; // of beperk tot een specifieke container
  const anchors = root.querySelectorAll('a[href]');

  // Geldige prefixen die we willen aanpassen
  const validPrefixes = ['/pages', '/products', '/collections', '/blogs', '/checkout'];

  anchors.forEach((a) => {
    const raw = a.getAttribute('href');
    if (!raw) return;

    const href = raw.trim();
    const lower = href.toLowerCase();

    // Sla over: anchors, mailto, tel, javascript, externe links
    if (href === '#' || href.startsWith('#')) return;
    if (lower.startsWith('mailto:') || lower.startsWith('tel:') || lower.startsWith('javascript:')) return;
    if (lower.startsWith('http://') || lower.startsWith('https://')) return;
    if (href.startsWith('//')) return;

    // Alleen aanpassen als de link met een van de geldige prefixen begint
    const matchPrefix = validPrefixes.find((p) => href.startsWith(p) || href.startsWith('/' + p));
    if (!matchPrefix) return;

    // Als de href al begint met /en/… → overslaan
    if (href.startsWith('/en/')) return;

    // Corrigeer de URL
    const newHref = href.startsWith('/')
      ? '/en' + href // bv. /products/x → /en/products/x
      : '/en/' + href; // bv. products/x → /en/products/x

    a.setAttribute('href', newHref);
  });
})();

/**
 * Vult de language-switcher modal: pakt alle hreflang-tags uit <head>
 * (geëmit door snippets/hreflang-tags.liquid) en zet de juiste href op
 * elke modal-anchor. Markeert de huidige taal actief via <html lang>-match.
 *
 * Server-side hreflang-set is leidend — geen rename of injectie meer in JS.
 */
(function () {
  const selector = document.querySelector('.available-languages');
  if (!selector) return;

  // Alle hreflang links uit <head> verzamelen
  const altLinks = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'));
  if (!altLinks.length) return;

  const hrefByLang = {};
  for (const link of altLinks) {
    const lang = (link.getAttribute('hreflang') || '').trim();
    const href = (link.getAttribute('href') || '').trim();
    if (lang && href && !hrefByLang[lang]) {
      hrefByLang[lang] = href;
    }
  }

  // Huidige taal van de pagina. theme.liquid zet dit als "taal-LAND"
  // (bv. "de-NL" of "de-DE"), terwijl de modal-anchors deels alleen de
  // taal dragen ("de") en deels taal+land ("nl-NL", "nl-BE", "fr-BE").
  const htmlLang = (document.documentElement.lang || '').trim().toLowerCase();
  const htmlLangBase = htmlLang.split('-')[0];

  // Voor elke anchor: href zetten (of uitgrijzen als er geen hreflang-tag voor is)
  const anchors = Array.from(selector.querySelectorAll('a[hreflang]'));
  anchors.forEach((a) => {
    const lang = a.getAttribute('hreflang');
    const href = hrefByLang[lang] || hrefByLang[lang.split('-')[0]];
    if (href) {
      a.setAttribute('href', href);
    } else {
      a.classList.add('opacity-50', 'pointer-events-none');
    }
  });

  // Precies één anchor actief markeren: eerst een exacte match op de volledige
  // hreflang (houdt nl-NL / nl-BE / en-NL uit elkaar), anders de anchor waarvan
  // de hreflang exact gelijk is aan de taal-subtag (de-DE -> "de", niet "en-NL").
  const langOf = (a) => (a.getAttribute('hreflang') || '').trim().toLowerCase();
  const current =
    anchors.find((a) => langOf(a) === htmlLang) ||
    anchors.find((a) => langOf(a) === htmlLangBase);

  if (current) {
    current.classList.add('active');
    current.setAttribute('aria-current', 'page');
    current.setAttribute('aria-selected', 'true');
  }
})();

(function () {
  // on doc ready
  document.addEventListener('DOMContentLoaded', () => {
    const reviewTabWrapper = document.querySelector('.jdgm-revs-tab__wrapper .jdgm-paginate');
    if (!reviewTabWrapper) return;
    // maak een span waarin staat "bekijk <a href="…">verzwaringsdeken</a> reviews"
    const reviewSpan = document.createElement('div');
    reviewSpan.classList.add('text-center', 'text-sm');
    reviewSpan.textContent = 'bekijk ';
    const reviewLink = document.createElement('a');
    reviewLink.href = 'https://novaline-dekens.nl/collections/verzwaringsdekens';
    reviewLink.textContent = 'verzwaringsdeken';
    reviewLink.target = '_blank';
    reviewLink.title = 'verzwaringsdeken';
    reviewLink.classList.add('!no-underline');
    reviewSpan.appendChild(reviewLink);
    reviewTabWrapper.appendChild(reviewSpan);
  });
})();
